import React, { createContext, ReactNode, useContext, useState } from 'react';

export type FlowType = 'flow1' | 'flow2' | 'flow3';

interface FlowContextType {
  currentFlow: FlowType;
  setCurrentFlow: (flow: FlowType) => void;
  getFlowStyles: () => {
    shadow: string;
    border: string;
  };
}

const FlowContext = createContext<FlowContextType | undefined>(undefined);

export const useFlow = () => {
  const context = useContext(FlowContext);
  if (!context) {
    throw new Error('useFlow must be used within a FlowProvider');
  }
  return context;
};

interface FlowProviderProps {
  children: ReactNode;
}

export const FlowProvider: React.FC<FlowProviderProps> = ({ children }) => {
  const [currentFlow, setCurrentFlow] = useState<FlowType>('flow1');

  const getFlowStyles = () => {
    switch (currentFlow) {
      case 'flow1':
        return {
          shadow: '',
          border: 'border border-[#E5E7EB]',
        };
      case 'flow2':
        return {
          shadow: '',
          border: 'border border-[#0C2340]',
        };
      case 'flow3':
        return {
          shadow: '',
          border: 'border border-[#E5E7EB]',
        };
      default:
        return {
          shadow: '',
          border: 'border border-[#E5E7EB]',
        };
    }
  };

  const value = {
    currentFlow,
    setCurrentFlow,
    getFlowStyles,
  };

  return <FlowContext.Provider value={value}>{children}</FlowContext.Provider>;
};
